// Angular imports
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

// RxJS imports
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Service imports
import { DatadogService } from '../_services/datadog.service';

/**
 * Reports every HttpErrorResponse to Datadog RUM at the interceptor layer,
 * independent of whether the caller catches and handles the error. Without
 * this, RUM only auto-captures request timing + status code, so traces show
 * "HTTP response has status code N" with no backend message or stack.
 *
 * HttpErrorResponse errors are NOT re-reported by RPErrorsHandler to avoid
 * double-counting; that handler now only addError's non-HTTP client errors.
 */
@Injectable()
export class DatadogErrorInterceptor implements HttpInterceptor {
  constructor(private readonly datadogService: DatadogService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          this.datadogService.addHttpError(err, req.method);
        }
        return throwError(() => err);
      })
    );
  }
}
